module.exports = __webpack_public_path__ + "static/media/range.fa21f0a8.png";